export default {
    SITE_A: { ip: '34.250.133.131', site: 'A' },
    SITE_B: { ip: '52.57.232.230', site: 'B' },
    UPTO_A: { ip: '18.202.184.90', customSite: 'UPTO A', site: 'A' },
    UPTO_B: { ip: '18.184.140.230', customSite: 'UPTO B', site: 'B' },
    INGE_A: { ip: '15.236.14.32', site: 'A' },
    INGE_B: { ip: '15.236.147.23', site: 'B' },
    DEV: { ip: '18.202.201.182' },
    STAGING: { ip: '54.78.238.21' }
};